import { FC } from "react";

import dynamic from "next/dynamic";

import { DonationFormSkeletonProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
export const DonationFormSkeleton = dynamic(
  () => import("./DonationFormSkeletonSsr").then((mod) => mod.DonationFormSkeletonSsr),
  {
    ssr: false,
  }
) as FC<DonationFormSkeletonProps>;
